/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { useGlobalState } from '@/hooks/useGlobalState';
import type { AlertType } from '@/types/globalState';
import useLatestCallback from 'use-latest-callback';

export const useAlerts = () => {
  const [alerts, setAlerts] = useGlobalState('alerts');

  const triggerAlert = useLatestCallback((alert: AlertType) => {
    setAlerts((prev) => ({ pendingAlerts: [...(prev.pendingAlerts ?? []), alert] }));
  });

  const clearAlert = useLatestCallback((alert: AlertType) => {
    setAlerts((prev) => ({ pendingAlerts: (prev.pendingAlerts ?? []).filter((a) => a !== alert) }));
  });

  return { alerts, triggerAlert, clearAlert };
};
